module.exports = __webpack_public_path__ + "static/img/Boss_31022.2b784903.png";